import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import Table from '../../../../TableResizable';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import { color } from '@mui/system';

import { Print, Save, SwipeUp, ViewAgenda, ViewColumn } from '@mui/icons-material';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Data from '../../../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../../Functions/Security/Crypter';
import { Box, Typography, styled } from '@mui/material';
import { ColumnsType } from 'antd/es/table';
import InputForm from '../../../../InputT';
import Amortissement from '../../../../../Functions/Traitement/Amortissement';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import formatDate from '../../../../../Functions/Traitement/fomatDate';
import Pret from '../../../../../Models/Pret';
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
//import "../../Assets/Styles/StyleForm.css";


const Tab1= (props: { form?: any ,data:any[]}) => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [pageLoad, setPageLoad] = useState(true)
  const [sbmit, setSbmit] = useState("")
  const [data, setData] = useState([])
  const navigate = useNavigate()


  const ThemeTable = styled(Table)(({ theme }) => ({

    ".ant-table-body": {
      height: '185px',
      borderBottom: '1px var(--colorOpaque020) solid',
    }
  }
  ));




  const SetStart = () => {
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    //form.resetFields()
  }

  // try {
  //   let localData = JSON.parse(localStorage.getItem(Data.LocalVariable.tabAmort) + "")
  //   form.setFieldsValue((localData.form))

  // } catch (error) {

  // }
  // if (pageLoad) {
  //   try {
  //     let localData = JSON.parse(localStorage.getItem(Data.LocalVariable.tabAmort) + "")
  //     //form.setFieldsValue((localData.form))
  //     let tab = localData.data as []

  //     tab.pop()
  //     tab.pop()

  //     setData(tab)
  //     //console.log(data)
  //     setPageLoad(false)
  //     SetStart()
  //     setImpActive(false)

  //   } catch (error) {

  //   }
  // }

  const columns: ColumnsType<any> = [
    {
      title: 'N° écheance',
      dataIndex: 'NumeroEch',
    },
    {
      title: 'Date Echéance',
      dataIndex: 'DateEcheance',
    },
     {
      title: 'Capital Initial',
      dataIndex: 'CapitalInitial',
    },
    {
      title: 'Amortissement',
      dataIndex: 'CapitalRembourse',
    },
    {
      title: 'Capital Restant',
      dataIndex: 'CapitalRestant',
    }
   
  ];

  //  : number,
  //  : number,
  // montantTA : number,
  // echeancierPlusTA : number,
  //  : number,
  // echeancierTot : number,
  //  : Date

  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }



  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
  }
  function handleAnulle() {
    setImpActive(true)
    setData([])
    props.form.resetFields()
    localStorage.clear()
    initialiazeButton()
    localStorage.setItem(Data.LocalVariable.reset, "1")
    //localStorage.setItem(Data.LocalVariable.resetTable, "1")
  }
  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)

  }

  function modifButton() {
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
  }



  const affiche = () => {
    try {
      let values: Pret = props.form.getFieldsValue()
      //localStorage.clear()

      setImpActive(false)

      let Amort: Amortissement = new Amortissement(values.NUMCLI, values.PERIODIC, values.MONTEPARG, values.TAUXINT, values.NBPERDIF, values.TYPEPRET, values.TYPAMORT, values.TAUXEPAR, values.NBRECHE, values.MONTAN, values.TYPCALC, values.TAUXTAX, ReformatDate(values.DAT1ECHE), values.MTNCOM1 + values.MTNCOM2 + values.MTNCOM3 + values.MTNCOM4 + values.MTNCOM5)
      //alert(JSON.stringify(Amort))

      setData(Amort.GetAmortissement() as [])

      props.form.setFieldsValue(Amortissement.totaux)
    } catch (error) {
      console.log(error)
    }

  };


  return (

    <div className='tabItem'>
      <div >
        <Box fontStyle="inherit" className='border' height={"60%"} width={"85%"} position={"absolute"}>
          <div className='clientP'>
            <div >
              <Box position={"relative"} display={"flex"} fontStyle="inherit" width={"99%"} className='border-left tabElement'>
                <Spin spinning={loading}>
                  <Table size='small' style={{ width: 'auto' }} columns={columns} dataSource={props.data} scroll={{ y: 220, x: 10 }} pagination={false} />
                </Spin>
                <Box display={"flex"} width={"%"} marginTop={"5%"} fontStyle="inherit" className='border-left bordure1 tabElement2'>
                  <InputForm money notRequired disabled width={8} label='Montant' name='MontantValide' type='number' error='mobile' />
                </Box>
              </Box>
            </div>
            <div>
            </div>
          </div>
        </Box>
      </div>
    </div>
  )
  
}
export default Tab1;